import { ProductBuilderMachineContext } from '../types';

type LiningColourOption = {
  id: string;
  title: string;
  price: number;
  variantId: number;
  width: number;
};

type GetLiningColourOptions = (
  context: ProductBuilderMachineContext,
) => LiningColourOption[];

export const getLiningColourOptions: GetLiningColourOptions = (context) => {
  const { curtainblock, curtainsemi, custom, supplier, products } = context;
  const measurements = custom.measurements;
  const lining = custom.lining;
  
 
  
  if (!measurements || !lining) {
    
    // If no measurements but we have a base product with metafields, return basic options
    if (lining && products && products[0] && products[0].metafields && products[0].metafields.lining_colour) {
      return products[0].metafields.lining_colour.map((color: string) => ({
        id: color.toLowerCase(),
        title: color,
        price: 0,
        variantId: 0,
        width: 0,
      }));
    }
    
    return [];
  }

  // Parse measurements to get width
  const [width] = measurements.split('x').map((value: string) => parseInt(value));
  
  if (!width) {
    return [];
  }

  // Determine which lining product to use based on lining selection
  let liningProduct;
  if (lining === 'Blockout' || lining === 'Block-out') {
    liningProduct = curtainblock && Array.isArray(curtainblock) && curtainblock.length > 0 
      ? curtainblock[0] 
      : null;
  } else if (lining === 'In-between/Dim Out' || lining === 'Semi-Transparent' || lining === 'Semi-transparent') {
    liningProduct = curtainsemi && Array.isArray(curtainsemi) && curtainsemi.length > 0 
      ? curtainsemi[0] 
      : null;
  } else {
    return [];
  }

  if (!liningProduct || !liningProduct.variants || !Array.isArray(liningProduct.variants)) {
    return [];
  }


  // Find variant that matches the width (100mm increments)
  const matchingVariant = liningProduct.variants.find(variant => {
    // Extract width from variant title (e.g., "400mm" from "400mm")
    const variantWidth = parseInt(variant.title.replace('mm', ''));
    return variantWidth >= width;
  });


  if (!matchingVariant) {
    
    // Fallback to metafields if no matching variant found
    if (products && products[0] && products[0].metafields && products[0].metafields.lining_colour) {
      return products[0].metafields.lining_colour.map((color: string) => ({
        id: color.toLowerCase(),
        title: color,
        price: 0,
        variantId: 0,
        width: 0,
      }));
    }
    
    return [];
  }

  // Find the currently selected color product instead of using products[0]
  const selectedColour = custom.colour;
  const currentProduct = selectedColour 
    ? products.find(product => 
        product.tags?.some(tag => 
          // Handle both exact match and case-insensitive partial match
          tag === selectedColour || 
          tag.toLowerCase() === selectedColour.toLowerCase() ||
          tag.toLowerCase().includes(selectedColour.toLowerCase())
        )
      )
    : products[0]; // Fallback to first product if no color selected
  
  const currentProductSupplier = currentProduct && currentProduct.metafields 
    ? currentProduct.metafields.supplier 
    : '';
  
  let colourOptions;
  
  if (currentProductSupplier === 'V1111') {
    colourOptions = ['White', 'Off White'];  // 2 colors for V1111
  } else {
    // Fallback for all other suppliers (including S1188)
    colourOptions = ['White', 'Beige', 'Gray', 'Taupe', 'Anthracite'];
  }
  

  
  return colourOptions.map(colour => ({
    id: colour.toLowerCase(),
    title: `${colour} - ${matchingVariant.title}`,
    price: matchingVariant.price,
    variantId: matchingVariant.id,
    width: parseInt(matchingVariant.title.replace('mm', '')),
  }));
};